import { useMemo, useState } from "react";
import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";

import {
  ButtonContainer,
  PreviewContainer,
  PreviewWrapper,
} from "./mobilePreview.style";

import { useAppSelector } from "../../../Redux/hooks";
import MobQuestionBlock from "./MobQuestionBlock";
import MobileMockup from "../../Common/UI/MobileMockup";

const MobilePreview = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const allQuestions = useAppSelector((state) => state.question.questions);
  const questionName = useAppSelector((state) => state.question.questionName);

  const questions = useMemo(
    () =>
      allQuestions ? allQuestions.filter((q) => !q.properties.isHidden) : [],
    [allQuestions]
  );
  const currentQuestion = useMemo(
    () => questions[currentPage - 1],
    [questions, currentPage]
  );

  const handleNext = () => {
    if (currentPage < questions.length) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <Box sx={PreviewWrapper}>
      <MobileMockup>
        <Stack gap={1} sx={PreviewContainer}>
          <Box sx={{ px: "10px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
                height: "20px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  width: "5ch",
                }}
                onClick={handlePrev}
              >
                {currentPage > 1 && (
                  <>
                    <ChevronLeft />
                    <Typography color={"primary"}>Back</Typography>
                  </>
                )}
              </Box>
              <Typography>
                {currentPage} of {questions.length}
              </Typography>
              <Typography color={"primary"}>Cancel</Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={(currentPage * 100) / questions.length}
              sx={{ borderRadius: 5 }}
            />
            <Typography variant="body1" color="primary" sx={{ mt: 0.5 }}>
              {questionName}
            </Typography>
          </Box>

          {questions.length > 0 && (
            <MobQuestionBlock
              question={currentQuestion}
              currentPage={currentPage}
            />
          )}

          <Box sx={ButtonContainer}>
            {!currentQuestion?.properties?.required && (
              <Button fullWidth variant="contained" onClick={handleNext}>
                Skip
              </Button>
            )}
            <Button
              fullWidth
              // endIcon={<East />}
              variant="contained"
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        </Stack>
      </MobileMockup>
    </Box>
  );
};

export default MobilePreview;
